import { Box, Paper, Typography, styled } from "@mui/material";

export const S = {
    BenchmarkList: styled(Box)(({ theme }) => ({
        position: "relative",
        display: "flex",
        gap: theme.spacing(4),
        width: "100%",
        maxWidth: "calc(100vw - 450px)",
        overflowX: "auto",
        scrollSnapType: "x mandatory",
        paddingRight: theme.spacing(2),
    })),

    Benchmark: styled(Paper)(({ theme }) => ({
        padding: theme.spacing(5, 6),
        borderRadius: theme.shape.borderRadius * 4,
        minWidth: 250,
        width: 450,
        border: `1px solid ${theme.palette.divider}`,
        scrollSnapAlign: "start",
        elevation: 0,
    })),

    Header: styled(Box)(() => ({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    })),

    Title: styled(Typography)(({ theme }) => ({
        fontSize: theme.typography.body2.fontSize,
        fontWeight: "bold",
        textTransform: "uppercase",
        color: "text.secondary",
    })),

    Segment: styled(Typography)(({ theme }) => ({
        fontSize: theme.typography.body2.fontSize,
        color: theme.palette.text.secondary,
    })),

    Unit: styled(Typography)(() => ({
        fontSize: 14,
        fontWeight: 700,
        marginLeft: 4,
        display: "inline-block",
    })),

    Value: styled(Typography)(() => ({
        fontSize: 26,
        fontWeight: 700,
        display: "inline-block",
    })),

    ValueLabel: styled(Typography)(({ theme }) => ({
        fontSize: 12,
        fontWeight: 400,
        color: theme.palette.text.secondary,
    })),
};
